import React from "react";

function CategoryItem(props) {
    return (
        <tr className="hover:bg-gray-50">
            <td className="px-6 py-4">
                <div className="flex items-center gap-4">
                    <img
                        src={props.image}
                        alt={props.name} className="w-16 h-16 rounded-lg object-cover"/>
                    <div>
                        <p className="font-semibold text-gray-800">{props.name}</p>
                        <p className="text-sm text-gray-500">ID: {props.id}</p>
                    </div>
                </div>
            </td>
            <td className="px-6 py-4 text-sm text-gray-600">{props.description}</td>
            <td className="px-6 py-4 text-sm font-medium text-gray-800">{props.productsListIDs.length}</td>
            <td className="px-6 py-4 text-right">
                <button onClick={props.onEdit}
                        className="text-custom-green hover:text-opacity-80 mr-3">
                    <i className="fa-solid fa-edit"></i>
                </button>
                <button onClick={props.onDelete} className="text-red-500 hover:text-red-700">
                    <i className="fa-solid fa-trash"></i>
                </button>
            </td>
        </tr>
    );

}

export default CategoryItem;